// ダウンロード系のAPI呼び出しのユーティリティ

import http from '../../api/http';
import { readBlobAsJson } from '../types/utility';
import { Error as ApiError } from '../../api/index';

const onError = (store: any): ((error: any) => Promise<any>) => {
    return (error: any) => {
        return readBlobAsJson(error.response.data)
            .catch(() => {
                // jsonパースエラー
                return { status: error.response.status };
            })
            .then(json => {
                let payload: { resData: ApiError } = { resData: json };
                if (!('status' in json)) {
                    payload.resData.status = error.response.status;
                }
                return store.dispatch('auth/apiError', payload, { root: true });
            });
    };
};

/*
 * API呼び出しは基本的にはvuex経由で行うこと
 * ただし、ダウンロードなどのvuexを経由すると実現できない機能は、例外的にこちらを使う
 */
export default {
    get: (store, url: string, onSuccess: (response: any) => void): Promise<any> => {
        return http
            .get(url, { responseType: 'blob' })
            .then(response => {
                onSuccess(response);
            })
            .catch(onError(store));
    },
};
